export enum DictionaryCode {
    ADDRESS_COUNTRY = 'ADDRESS_COUNTRY',
    ADDRESS_STREET_PREFIX = 'ADDRESS_STREET_PREFIX',
    ADDRESS_VOIVODESHIP = 'ADDRESS_VOIVODESHIP',
    ASSORTMENT_GROUP = 'ASSORTMENT_GROUP',
    ASSORTMENT_SUBGROUP = 'ASSORTMENT_SUBGROUP',
    BARCODE_ALGORITHM = 'BARCODE_ALGORITHM',
    DOCUMENT_CATEGORY = 'DOCUMENT_CATEGORY',
    LOCALIZATION_PERMISSION_TYPE = 'LOCALIZATION_PERMISSION_TYPE',
    PARTNER_LEGAL_FORM = 'PARTNER_LEGAL_FORM',
    PARTNER_SETTLEMENT = 'PARTNER_SETTLEMENT',
    PASS_GROUPS = 'PASS_GROUPS',
    POLICY_PAYMENT_TYPES = 'POLICY_PAYMENT_TYPES',
    PARTY_TYPE = 'PARTY_TYPE',
    POLICY_PURCHASE_TYPE = 'POLICY_PURCHASE_TYPE',
    POLICY_ACCESS = 'POLICY_ACCESS',
    POLICY_STATUS = 'POLICY_STATUS',
    PRODUCT_DPG_MODE = 'PRODUCT_DPG_MODE',
    PRODUCT_GROUPS = 'PRODUCT_GROUPS',
    PRODUCT_INSURANCE_PERIOD = 'PRODUCT_INSURANCE_PERIOD',
    PRODUCT_INSURANCE_START_MODE = 'PRODUCT_INSURANCE_START_MODE',
    PRODUCT_PRINT_ORDER = 'PRODUCT_PRINT_ORDER',
    PRODUCT_SELL_TYPES = 'PRODUCT_SELL_TYPES',
    PRODUCT_STATUS = 'PRODUCT_STATUS',
    PRODUCT_WARRANTY = 'PRODUCT_WARRANTY',
    PRODUCT_TYPE = 'PRODUCT_TYPE',
    USER_ROLES = 'USER_ROLES',
    VALUE_TYPE = 'VALUE_TYPE',
    GENDER = 'GENDER',
    CITIZENSHIP = 'CITIZENSHIP',
    CLAUSES = 'CLAUSES',
    DOCUMENT_TYPE = 'DOCUMENT_TYPE',
    TERMINATION_REASON = 'TERMINATION_REASON',
}
